// export const API_URL = "http://localhost:8080";
export const API_URL = "https://api.vishnujimaharaj.com";
